import { render } from "./Highlight.vue?vue&type=template&id=1c665478&scoped=true"
import script from "./Highlight.vue?vue&type=script&lang=js"
export * from "./Highlight.vue?vue&type=script&lang=js"

import "@/components/AboutMe/Highlight/style.scss?vue&type=style&index=0&id=1c665478&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c665478"]])

export default __exports__